"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllFeatureSubKey = exports.AllModules = exports.AllChannels = exports.FeatureCategory = exports.FeatureKeyToPlanMapping = exports.Features = exports.ROUTES = void 0;
const billing_1 = require("./billing");
var ROUTES;
(function (ROUTES) {
    ROUTES["WHATSAPP_LOGIN"] = "Whatsapp Login";
    ROUTES["WHATSAPP_MARKETING_HOME"] = "Home";
    ROUTES["BROADCAST_LIST"] = "Campaigns";
    ROUTES["CONTENTS"] = "Template contents";
    ROUTES["TEMPLATES"] = "Templates";
    ROUTES["SEGMENTS_MANAGEMENT"] = "Segments";
    ROUTES["CHAT"] = "Inbox";
    ROUTES["CONTACT"] = "Contact Detail";
    ROUTES["WHATSAPP_CUSTOMER_CHAT_VIEW"] = "Customer Chat";
    ROUTES["AUTOMATIONS"] = "Automations";
    ROUTES["PUBLISHED_FLOWS"] = "Published Flows";
    ROUTES["CHATBOT"] = "Chatbot";
    ROUTES["CHATFLOWS"] = "Chatflows";
    ROUTES["CHATFLOW_SETTINGS"] = "Manage Variables";
    ROUTES["JOURNEYS"] = "Journeys";
    ROUTES["JOURNEYS_HOME"] = "Journeys Home";
    ROUTES["JOURNEY_LIBRARY"] = "Journey Library";
    ROUTES["ANALYTICS"] = "Analytics";
    ROUTES["ACQUISITIONS"] = "Acquisitions";
    ROUTES["CTWA"] = "CTWA";
    ROUTES["WEB_WIDGETS"] = "Web widgets";
    ROUTES["GROWTH_TOOLS"] = "Growth tools";
    ROUTES["CONTACT_LIST"] = "Contacts";
    ROUTES["LOGIN_ID"] = "LOGIN_ID";
    ROUTES["LOGIN"] = "Login";
    ROUTES["OVERVIEW"] = "Overview";
    ROUTES["POLICIES"] = "Policies";
    ROUTES["APPROVALS"] = "Approvals";
    ROUTES["ORDERS"] = "Orders";
    ROUTES["CUSTOM_FIELDS"] = "Custom Fields";
    ROUTES["SUPPORT_QUERIES"] = "Support Tickets";
    ROUTES["LAYOUT"] = "Layout";
    ROUTES["ORDER_DETAILS"] = "Order Details";
    ROUTES["CUSTOMERS"] = "Customers List";
    ROUTES["COHORT_SELECTION"] = "Select Cohort";
    ROUTES["BROADCAST_TEMPLATE_SELECTION"] = "Select Template";
    ROUTES["EDIT_BROADCAST_TEMPLATE"] = "Edit Template";
    ROUTES["REVIEW_BROADCAST"] = "Review Campaign";
    ROUTES["MERCHANT_WALLET_WEBVIEW"] = "Wallet";
    ROUTES["ONBOARDING"] = "Onboarding";
    ROUTES["LOGOUT"] = "LOGOUT";
    ROUTES["CHARTJS"] = "CHARTJS";
    ROUTES["MANUAL_ORDER"] = "Create order";
    ROUTES["SHOPIFY"] = "Shopify";
    ROUTES["STAFF_MANAGEMENT"] = "Staff Management";
    ROUTES["LABELS_SETTINGS"] = "Labels Settings";
    ROUTES["QUICK_REPLIES"] = "Quick Replies";
    ROUTES["ADD_STAFF"] = "Add Staff";
    ROUTES["EDIT_STAFF"] = "Edit Staff";
    ROUTES["STAFF_PROFILE"] = "Staff Profile";
    ROUTES["BROADCASTS_OVERVIEW"] = "Campaigns Overview";
    ROUTES["BROADCAST_DETAILS"] = "Campaign Details";
    ROUTES["TEMPLATE_CREATE"] = "Create template";
    ROUTES["TEMPLATE_EDIT"] = "Edit template";
    ROUTES["TEMPLATE_EDIT_NEW"] = "Edit Template multi";
    ROUTES["TEMPLATE_CREATE_NEW"] = "Create Template  multi";
    ROUTES["SETTINGS"] = "Settings";
    ROUTES["SETTINGS_CHAT_ASSIGNMENT_PAGE"] = "Assignment Logic";
    ROUTES["ACCOUNT"] = "Account";
    ROUTES["PAYMENTS_AND_CREDITS"] = "Credits";
    ROUTES["SEGMENTS_CREATE_FILTER"] = "Segment creation screen";
    ROUTES["CAMPAIGN_ANALYTICS"] = "Campaign Analytics";
    ROUTES["CAMPAIGN_DETAIL"] = "Campaign detail";
    ROUTES["WIDGET"] = "Widget";
    ROUTES["TEMPLATE_DESIGN"] = "Template design";
    ROUTES["SEGMENTS_DETAILS"] = "Segments Details";
    ROUTES["TEMPLATE_GRAPHICS"] = "Template graphics";
    ROUTES["SEGMENTS_CREATE"] = "Create Segments";
    ROUTES["WA_CHAT_URL_GENERATOR"] = "Whatsapp chat URL generator";
    ROUTES["QR_GENERATOR"] = "QR code generator";
    ROUTES["CRM_ANALYTICS"] = "CRM Analytics";
    ROUTES["Integrations_Old"] = "Integrations_Old";
    ROUTES["INTEGRATION"] = "Integrations";
    ROUTES["API_REFERENCE"] = "Custom Integration";
    ROUTES["GOOGLE_BUSINESS_INFO"] = "GOOGLE_BUSINESS_INFO";
    ROUTES["GOOGLE_BUISNESS_MANAGER"] = "GOOGLE_BUISNESS_MANAGER";
    ROUTES["CREATE_BROADCAST"] = "Create campaign";
    ROUTES["PERSISTENT_MENU"] = "Persistent Menu";
    ROUTES["PRICE_PLEASE"] = "Price Please";
    ROUTES["CONVERSATION_STARTER"] = "Conversation Starter";
    ROUTES["AUTOMATION_LIBRARY"] = "Automation library";
    ROUTES["CHATFLOW_LIBRARY"] = "Chatflow library";
    ROUTES["TEMPLATE_LIBRARY"] = "Template library";
    ROUTES["MY_TEMPLATES"] = "My Templates";
    ROUTES["STW"] = "STW";
    ROUTES["DUMMY_PRODUCTS"] = "Dummy Products";
    ROUTES["CHANNEL_SETTINGS"] = "Channel Settings";
    ROUTES["CHAT_STAGES"] = "Chat Stages";
})(ROUTES = exports.ROUTES || (exports.ROUTES = {}));
var Features;
(function (Features) {
    Features["INSTAGRAM_E2E_SHOPPING_CHATBOT"] = "Instagram end to end Shopping chatbot";
    Features["WHATSAPP"] = "WHATSAPP";
    Features["INSTAGRAM"] = "INSTAGRAM";
    Features["WIDGETS"] = "WIDGETS";
    Features["CTWA"] = "CTWA";
    Features["WHATSAPP_BUILDER"] = "Whatsapp builder";
    Features["INSTAGRAM_BUILDER"] = "Instagram builder";
    Features["EMAIL_BUILDER"] = "Email builder";
})(Features = exports.Features || (exports.Features = {}));
exports.FeatureKeyToPlanMapping = {
    [Features.INSTAGRAM]: {
        supportingPlans: [
            billing_1.PACKAGENAMES.BIK_INSTAGRAM_PLAN,
            billing_1.PACKAGENAMES.BIK_GROWTH_PLAN,
            billing_1.PACKAGENAMES.BIK_BUSINESS_PLAN,
            billing_1.PACKAGENAMES.BIK_CUSTOM_PLAN,
        ],
        restrictInEnterpise: false,
    },
    [Features.WHATSAPP]: {
        supportingPlans: [
            billing_1.PACKAGENAMES.BIK_GROWTH_PLAN,
            billing_1.PACKAGENAMES.BIK_BUSINESS_PLAN,
            billing_1.PACKAGENAMES.BIK_CUSTOM_PLAN,
        ],
        restrictInEnterpise: false,
    },
    [Features.INSTAGRAM_E2E_SHOPPING_CHATBOT]: {
        supportingPlans: [
            billing_1.PACKAGENAMES.BIK_INSTAGRAM_PLAN,
            billing_1.PACKAGENAMES.BIK_GROWTH_PLAN,
            billing_1.PACKAGENAMES.BIK_BUSINESS_PLAN,
            billing_1.PACKAGENAMES.BIK_CUSTOM_PLAN,
        ],
        restrictInEnterpise: false,
    },
    [ROUTES.ANALYTICS]: {
        supportingPlans: [billing_1.PACKAGENAMES.BIK_CUSTOM_PLAN],
        restrictInEnterpise: false,
    },
    [Features.WIDGETS]: {
        supportingPlans: [
            billing_1.PACKAGENAMES.BIK_GROWTH_PLAN,
            billing_1.PACKAGENAMES.BIK_BUSINESS_PLAN,
            billing_1.PACKAGENAMES.BIK_CUSTOM_PLAN
        ],
        restrictInEnterpise: false,
    },
    [Features.CTWA]: {
        supportingPlans: [
            billing_1.PACKAGENAMES.BIK_BUSINESS_PLAN,
            billing_1.PACKAGENAMES.BIK_CUSTOM_PLAN,
            billing_1.PACKAGENAMES.BIK_GROWTH_PLAN
        ],
        restrictInEnterpise: false,
    },
    [ROUTES.BROADCASTS_OVERVIEW]: {
        supportingPlans: [
            billing_1.PACKAGENAMES.BIK_GROWTH_PLAN,
            billing_1.PACKAGENAMES.BIK_BUSINESS_PLAN,
            billing_1.PACKAGENAMES.BIK_CUSTOM_PLAN,
        ],
        restrictInEnterpise: false,
    },
    [ROUTES.SEGMENTS_MANAGEMENT]: {
        supportingPlans: [
            billing_1.PACKAGENAMES.BIK_GROWTH_PLAN,
            billing_1.PACKAGENAMES.BIK_BUSINESS_PLAN,
            billing_1.PACKAGENAMES.BIK_CUSTOM_PLAN,
        ],
        restrictInEnterpise: false,
    },
    [Features.WHATSAPP_BUILDER]: {
        supportingPlans: [
            billing_1.PACKAGENAMES.BIK_GROWTH_PLAN,
            billing_1.PACKAGENAMES.BIK_BUSINESS_PLAN,
            billing_1.PACKAGENAMES.BIK_CUSTOM_PLAN,
        ],
        restrictInEnterpise: false,
    },
    [Features.INSTAGRAM_BUILDER]: {
        supportingPlans: [
            billing_1.PACKAGENAMES.BIK_INSTAGRAM_PLAN,
            billing_1.PACKAGENAMES.BIK_GROWTH_PLAN,
            billing_1.PACKAGENAMES.BIK_BUSINESS_PLAN,
            billing_1.PACKAGENAMES.BIK_CUSTOM_PLAN,
        ],
        restrictInEnterpise: false,
    },
    [Features.EMAIL_BUILDER]: {
        supportingPlans: [
            billing_1.PACKAGENAMES.BIK_GROWTH_PLAN,
            billing_1.PACKAGENAMES.BIK_BUSINESS_PLAN,
            billing_1.PACKAGENAMES.BIK_CUSTOM_PLAN,
        ],
        restrictInEnterpise: false,
    },
    [ROUTES.BROADCAST_LIST]: {
        supportingPlans: [
            billing_1.PACKAGENAMES.BIK_GROWTH_PLAN,
            billing_1.PACKAGENAMES.BIK_BUSINESS_PLAN,
            billing_1.PACKAGENAMES.BIK_CUSTOM_PLAN,
        ],
        restrictInEnterpise: false,
    },
    [ROUTES.MY_TEMPLATES]: {
        supportingPlans: [
            billing_1.PACKAGENAMES.BIK_GROWTH_PLAN,
            billing_1.PACKAGENAMES.BIK_BUSINESS_PLAN,
            billing_1.PACKAGENAMES.BIK_CUSTOM_PLAN,
        ],
        restrictInEnterpise: false,
    },
    [ROUTES.JOURNEYS_HOME]: {
        supportingPlans: [
            billing_1.PACKAGENAMES.BIK_GROWTH_PLAN,
            billing_1.PACKAGENAMES.BIK_BUSINESS_PLAN,
            billing_1.PACKAGENAMES.BIK_CUSTOM_PLAN,
        ],
        restrictInEnterpise: false,
    },
};
var FeatureCategory;
(function (FeatureCategory) {
    FeatureCategory["channel"] = "channel";
    FeatureCategory["module"] = "modules";
})(FeatureCategory = exports.FeatureCategory || (exports.FeatureCategory = {}));
var AllChannels;
(function (AllChannels) {
    AllChannels["whatsapp"] = "whatsapp";
    AllChannels["instagram"] = "instagram";
    AllChannels["gmail"] = "gmail";
    AllChannels["messenger"] = "messenger";
    AllChannels["webpush"] = "webpush";
    AllChannels["email"] = "email";
})(AllChannels = exports.AllChannels || (exports.AllChannels = {}));
var AllModules;
(function (AllModules) {
    AllModules["automations"] = "automations";
    AllModules["campaigns"] = "campaigns";
    AllModules["helpdesk"] = "helpdesk";
    AllModules["popup"] = "popup";
})(AllModules = exports.AllModules || (exports.AllModules = {}));
var AllFeatureSubKey;
(function (AllFeatureSubKey) {
    AllFeatureSubKey["ADD_NOTES"] = "ADD_NOTES";
    AllFeatureSubKey["RE_ASSIGN_TICKETS"] = "RE_ASSIGN_TICKETS";
    AllFeatureSubKey["WHATSAPP_TEMPLATE_COMPOSER"] = "WHATSAPP_TEMPLATE_COMPOSER";
    AllFeatureSubKey["EMAIL_TEMPLATE_COMPOSER"] = "EMAIL_TEMPLATE_COMPOSER";
    AllFeatureSubKey["ADD_LABELS"] = "ADD_LABELS";
    AllFeatureSubKey["QUICK_REPLIES"] = "QUICK_REPLIES";
    AllFeatureSubKey["EMAIL_REPLY"] = "EMAIL_REPLY";
    AllFeatureSubKey["WHATSAPP_TEMPLATE_REPLY"] = "WHATSAPP_TEMPLATE_REPLY";
    AllFeatureSubKey["ADD_VIEWS"] = "ADD_VIEWS";
    AllFeatureSubKey["START_CAMPAIGN"] = "START_CAMPAIGN";
    AllFeatureSubKey["SCHEDULE_CAMPAIGN"] = "SCHEDULE_CAMPAIGN";
    AllFeatureSubKey["CONVERSATION_STARTER"] = "CONVERSATION_STARTER";
    AllFeatureSubKey["PERSISTENT_MENU"] = "PERSISTENT_MENU";
    AllFeatureSubKey["FLOW_ACTIVATIONS"] = "FLOW_ACTIVATIONS";
    AllFeatureSubKey["PRICE_PLEASE"] = "PRICE_PLEASE";
    AllFeatureSubKey["POPUP"] = "POPUP";
    AllFeatureSubKey["CHAT_STAGES"] = "CHAT_STAGES";
    AllFeatureSubKey["SNOOZE_TICKETS"] = "SNOOZE_TICKETS";
    AllFeatureSubKey["CREATE_TASKS"] = "CREATE_TASKS";
    AllFeatureSubKey["DISABLE_TEST_MODE"] = "DISABLE_TEST_MODE";
    AllFeatureSubKey["TRIGGER_JOURNEY"] = "TRIGGER_JOURNEY";
    AllFeatureSubKey["FOOTER_TEXT"] = "FOOTER_TEXT";
})(AllFeatureSubKey = exports.AllFeatureSubKey || (exports.AllFeatureSubKey = {}));
